import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardFacade } from '../store/dashboard.facade';

@Component({
  selector: 'app-abouttoexpirewidget',
  templateUrl: './abouttoexpirewidget.component.html',
  styleUrls: ['./abouttoexpirewidget.component.scss'],
   encapsulation: ViewEncapsulation.None
})
export class AbouttoexpirewidgetComponent implements OnInit {

  public fetchAboutToExpire = this.dashboardFacade$.aboutToExpire$;
  constructor(private dashboardFacade$: DashboardFacade) { }

  ngOnInit(): void {
    this.dashboardFacade$.fetchAboutToExpire()
  }

}